import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { apolloClient } from './lib/apollo';
import { AuthProvider } from './lib/auth-context';
import { ToastProvider } from './components/ui/toast';
import { initPostHog } from './lib/posthog';
import { isStaleChunkError, reloadOnceForStaleChunk } from './lib/stale-chunk-reload';
import App from './App';
import './index.css';

if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    const payload = event instanceof CustomEvent ? event.payload : undefined;

    if (reloadOnceForStaleChunk(payload)) {
      event.preventDefault();
    }
  });
}

initPostHog();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>
);

// Initialize Sentry after the page is interactive — not on the critical render path.
// This keeps it out of the initial JS parse/execution budget.
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    import('./lib/sentry')
      .then(({ initSentry }) => initSentry())
      .catch((error) => {
        if (isStaleChunkError(error)) return;
        console.error('[Sentry] Failed to initialize:', error);
      });
  });
}
